import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import routeConstants from '../utils/routeConstants';
import {
  endRouteActionsTypes,
  bookingAvailabilityStatuses
} from '../utils/constants';
import {
  processActionIfUserLogged,
  processActionIfUserSubscribe
} from '../actions/routingActions';
import { startSessionBooking } from '../actions/sessionsBookingActions';
import { setPendingBookingSessionEventId } from '../actions/pendingBookingActions';
import QuickBookingContainer from './QuickBookingContainer';
import i18n from '../utils/i18n';
import './styles/QuickBookingContainer.scss';

class QuickBookingSessions extends React.Component {
  constructor(props) {
    super(props);

    this.startBooking = this.startBooking.bind(this);
    this.cancelBooking = this.cancelBooking.bind(this);
    this.confirmBooking = this.confirmBooking.bind(this);
  }

  startBooking() {
    const { event } = this.props;
    this.props.processActionIfUserLogged(
      () => {
        this.props.setPendingBookingSessionEventId(event.id);
      },
      event,
      this.props.backRoute,
      endRouteActionsTypes.PENDING_SESSION_BOOKING
    );
  }

  cancelBooking() {
    this.props.setPendingBookingSessionEventId(null);
  }

  confirmBooking(bookingsNumber) {
    const { event } = this.props;
    const inviteFriendsCount = bookingsNumber - event.user_limit;
    const startSessionBookingAction = () => {
      this.props.startSessionBooking(
        bookingsNumber,
        event.id,
        event.event_date,
        event.start_time,
        event.name,
        event.venue_location,
        event.venue_club_name,
        this.props.refreshAction,
        inviteFriendsCount
      );
    };

    if (
      event.booking_availability_status ===
      bookingAvailabilityStatuses.AVAILABLE
    ) {
      startSessionBookingAction();
    } else {
      this.props.processActionIfUserSubscribe(
        () => {
          startSessionBookingAction();
        },
        event,
        this.props.backRoute,
        endRouteActionsTypes.PENDING_SESSION_BOOKING
      );
    }
  }

  render() {
    const pendingBookingEventIdAvailable =
      this.props.pendingBookingEventId !== null;
    return (
      <QuickBookingContainer
        radioOptions={ [
          {
            value: 1,
            label: '1'
          }
        ] }
        defaultRadioValue={ 1 }
        radioButtonsLabel={ i18n.t('singleSessionScreen.ATTENDIES') }
        startBooking={ this.startBooking }
        cancelBooking={ this.cancelBooking }
        confirmBooking={ this.confirmBooking }
        pendingBooking={
          pendingBookingEventIdAvailable &&
          this.props.event.id === this.props.pendingBookingEventId
        }
        greyOut={
          pendingBookingEventIdAvailable &&
          this.props.event.id !== this.props.pendingBookingEventId
        }
        backRoute={ this.props.backRoute }
      >
        {this.props.children}
      </QuickBookingContainer>
    );
  }
}

QuickBookingSessions.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    remaining_limit_for_user: PropTypes.number
  }),
  children: PropTypes.node,
  setPendingBookingSessionEventId: PropTypes.func.isRequired,
  startSessionBooking: PropTypes.func.isRequired,
  refreshAction: PropTypes.func,
  pendingBookingEventId: PropTypes.number,
  backRoute: PropTypes.string,
  processActionIfUserSubscribe: PropTypes.func.isRequired,
  processActionIfUserLogged: PropTypes.func.isRequired
};

QuickBookingSessions.defaultProps = {
  event: {
    id: null,
    remaining_limit_for_user: 0
  },
  children: null,
  refreshAction: () => {},
  pendingBookingEventId: null,
  backRoute: ''
};

const mapStateToProps = state => ({
  pendingBookingEventId: state.pendingBooking.sessionEventId
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  setPendingBookingSessionEventId: eventId =>
    dispatch(setPendingBookingSessionEventId(eventId)),
  processActionIfUserSubscribe: (
    action,
    event,
    backRoute,
    endRouteActionType
  ) =>
    dispatch(
      processActionIfUserSubscribe(action, event, backRoute, endRouteActionType)
    ),
  processActionIfUserLogged: (action, event, backRoute, endRouteActionType) =>
    dispatch(
      processActionIfUserLogged(action, event, backRoute, endRouteActionType)
    ),
  startSessionBooking: (
    bookingsNumber,
    sessionEventId,
    eventDate,
    eventTime,
    sessionName,
    eventLocation,
    eventClubName,
    refreshAction,
    inviteFriendsCount
  ) =>
    dispatch(
      startSessionBooking(
        bookingsNumber,
        sessionEventId,
        eventDate,
        eventTime,
        sessionName,
        eventLocation,
        eventClubName,
        refreshAction,
        inviteFriendsCount
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuickBookingSessions);



// WEBPACK FOOTER //
// ./src/containers/QuickBookingSessions.js